import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-flamingo-opt-confirm-dialog',
    template: `
        <h2 mat-dialog-title>{{ data.title }}</h2>
        <div mat-dialog-content>
            <p [innerHtml]="data.description"></p>
            <mat-checkbox aria-label="Never Ask Again" (change)="setNeverAskAgain($event.checked)">
                <span>{{ data.neverAskAgainText }}</span>
            </mat-checkbox>
        </div>
        <div mat-dialog-actions [align]="'end'">
            <button [tabIndex]="-1" type="button" *ngIf="data.cancel" mat-button
                    [mat-dialog-close]="close(false)">{{ data.cancel }}
            </button>
            <button mat-flat-button [mat-dialog-close]="close(true)" class="btn-margin">{{ data.confirm }}</button>
        </div>
    `,
    standalone: false,
})
export class FlamingoOptConfirmDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<FlamingoOptConfirmDialogOptions>,
        @Inject(MAT_DIALOG_DATA) public data: FlamingoOptConfirmDialogOptions) {
    }

    neverAskAgain: boolean = false;

    close(res: boolean): FlamingoOptConfirmDialogResult {
        return {
            result: res,
            neverAskAgain: this.neverAskAgain
        };
    }

    setNeverAskAgain(res: boolean): void {
        this.neverAskAgain = res;
    }
}

export interface FlamingoOptConfirmDialogOptions {
    key: string;
    title?: string;
    description?: string;
    neverAskAgainText?: string;
    confirm?: string;
    cancel?: string;
}

export interface FlamingoOptConfirmDialogResult {
    result: boolean;
    neverAskAgain: boolean;
}
